/**
 * PROPS
 *
 * marginTop => margin top compoenent | default 0px | string
 * marginBottom => margin bottom compoenent | default 0px | string
 */

import React from "react";
import Image from "next/image";
import PropTypes from "prop-types";
import Vars from "Consts/vars";

const InstructionTicketDesktop = (props) => {

	const {
		marginTop,
		marginBottom,
	} = props;

	return (
		<>
			<div className="instruction">
				<div className="instruction-container">
					<div className="instruction-left">
						<h1 className="instruction-left__title">Instruksi <br /> Penukaran Tiket</h1>
						<p className="instruction-left__description">Belum punya Female Daily Apps? Download yuk </p>
						<div className="instruction-left__app">
							<a href="https://itunes.apple.com/id/app/female-daily-beauty-review/id1160742672?l=id&amp;mt=8" target="_blank" rel="noopener noreferrer">
								<Image layout="fixed" src="https://image.femaledaily.com/dyn/300/web-assets/btn_appstore.png" width="135px" height="40px" alt="play-store" />
							</a>
							<a href="https://play.google.com/store/apps/details?id=com.fdbr.android&amp;hl=en_GB" target="_blank" rel="noopener noreferrer">
								<Image layout="fixed" src="https://image.femaledaily.com/dyn/300/web-assets/btn_playstore.png" width="135px" height="40px" alt="app-store" />
							</a>
						</div>
					</div>
					<ul className="instruction-right">
						<p className="text-danger">Info Penting!</p>
						{
							Vars.INSTRUCTION.map((item) => (
								<li className="list-box" key={item.id}>
									<div className="list-box__number">{item.id}</div>
									<div className="list-box__text">
										<h4>{item.title}</h4>
										<p>{item.content}</p>
									</div>
								</li>
							))
						}
					</ul>
				</div>
			</div>
			<style jsx>{`
        .instruction {
          position: relative;
          width: 100%;
          height: auto;
          padding: 0;
          margin: ${marginTop} 0 ${marginBottom} 0;
          text-align: center;
        }
        .instruction-container {
          width: 100%;
          max-width: 962px;
          margin: 0 auto;
          display: flex;
          justify-content: space-between; 
        }
        .instruction-left {
          height: auto;
          display: flex; 
          align-items: flex-start; 
          flex-direction: column; 
          gap: 16px
          box-sizing: border-box;
        }
        .instruction-left__title {
          font-family: 'Poppins';
          font-style: normal;
          font-weight: 600;
          font-size: 32px;
          line-height: 48px;
          text-transform: capitalize;
          color: #13161A;
          text-align: left;
          margin: 0;
        }
        .instruction-left__description {
          font-family: 'Roboto';
          font-style: normal;
          font-weight: 400;
          font-size: 16px;
          line-height: 24px;
          color: #637381;
          margin: 24px 0 0 0;
        }
        .instruction-left__app {
          display: flex;
          gap: 16px;
          margin-top: 16px;
        }
        .instruction-right {
          width: 452px;
          height: auto;
          display: flex; 
          flex-direction: column; 
          gap: 23px;
          margin: 0;
          margin-bottom: 23px;
        }
        .text-danger {
          font-family: 'Poppins';
          font-style: normal;
          font-weight: 600;
          font-size: 16px;
          line-height: 24px;
          color: #FF4D4F;
          margin: 0;
          text-align: left;
        } 
        .list-box {
          display: flex;
          gap: 16px;
          align-items: flex-start;
        }
        .list-box__number {
          font-family: 'Roboto';
          font-style: normal;
          font-weight: 500;
          font-size: 14px;
          line-height: 22px;
          color: #FFFFFF;
          left: -7px;
          width: 100%;
          max-width: 22px;
          height: 22px;
          background: #000000;
          border-radius: 50%;
          margin-top: 3px;
          text-align: center;
          
        }
        .list-box__text {
          border-bottom: 1px solid #DFE3E8;
        }
        .list-box__text > h4 {
          font-family: 'Poppins';
          font-style: normal;
          font-weight: 600;
          font-size: 16px;
          line-height: 24px;
          text-transform: capitalize;
          margin: 0;
          text-align: left;
        }
        .list-box__text > p {
          font-family: 'Roboto';
          font-style: normal;
          font-weight: 400;
          font-size: 14px;
          line-height: 22px;
          color: #13161A;
          margin: 8px 0 16px 0;
          text-align: left;
        }
      `}
			</style>
		</>
	);

};

InstructionTicketDesktop.propTypes = {
	marginTop: PropTypes.string,
	marginBottom: PropTypes.string,
};

InstructionTicketDesktop.defaultProps = {
	marginTop: "0px",
	marginBottom: "0px",
};

export default InstructionTicketDesktop;
